import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]

import { useUserStore } from '@/store/users';
import { NavigationItem } from '@/typings/navigation';
import { computed, PropType, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object as PropType<NavigationItem>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const userStore = useUserStore();

const { item } = toRefs(props);

const loggedIn = computed((): boolean => !!userStore.user);

const requiresLoggedOut = computed(
  (): boolean => !item.value.requiresLogin && !loggedIn.value
);

const requiresLogin = computed(
  (): boolean => item.value.requiresLogin && loggedIn.value
);

const isAdmin = computed(
  (): boolean =>
    requiresLogin.value &&
    item.value.adminOnly &&
    userStore.user?.PrivilegeId === 1
);

const doShow = computed(
  (): boolean =>
    requiresLoggedOut.value ||
    (requiresLogin.value && !item.value.adminOnly) ||
    (requiresLogin.value && isAdmin.value) ||
    item.value.alwaysVisible
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(doShow))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(item).route)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(item).external)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "px-4 cursor-pointer hover:text-primary",
                    href: _unref(item).route,
                    target: "_blank"
                  }, _toDisplayString(_unref(item).label), 9, _hoisted_2))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "px-4 cursor-pointer hover:text-primary",
                    to: _unref(item).route
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(item).label), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
            ], 64))
          : _createCommentVNode("", true),
        (_unref(item).action)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "px-4 cursor-pointer hover:text-primary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(item).action && _unref(item).action(...args)), ["stop"]))
            }, _toDisplayString(_unref(item).label), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})